import React from 'react';
import { 
	Modal,
} from 'react-bootstrap';
import { 
	func, 
	bool,
	oneOfType,
	string,
	object
} from 'prop-types';

import TextButton from '../../atoms/TextButton/index';
import style from './style';

const Presenter = ({
	show,
	onHide,
	error
}) =>{
	return <Modal 
		show={show} 
		onHide={onHide}
		bsSize="large">
		<Modal.Header closeButton>
			ERROR
		</Modal.Header>
		<Modal.Body>
			<style.BodyWrapper>
				<style.EditorWrapper>
					{error}
				</style.EditorWrapper>
			</style.BodyWrapper>
		</Modal.Body>
		<Modal.Footer>
			<TextButton onClick={onHide}>Cancel</TextButton>
		</Modal.Footer>
	</Modal>;
};

Presenter.propTypes = {
	show:bool,
	onHide:func.isRequired,
	error:oneOfType([string,object])
};

export default Presenter;